export const EVENTS = {
  PAGE_VIEW: {
    name: "Page View",
    properties: {
      PAGE_NAME: "Page Name"
    }
  },
  EXPERIMENT_VIEWED: {
    name: "Experiment Viewed",
    properties: {
      EXPERIMENT_NAME: "Experiment Name",
      EXPERIMENT_VARIATION: "Experiment Variation"
    }
  },
  EXPERIMENT_LINK_CLICKED: {
    name: "Experiment Link Clicked",
    properties: {
      EXPERIMENT_NAME: "Experiment Name",
      EXPERIMENT_VARIATION: "Experiment Variation",
      LINK_ID: "Link ID",
      ELEMENT_TYPE: "Element Type"
    }
  },
  START_REGISTRATION: {
    name: "Start Registration",
    properties: {
      ACCOUNT_TYPE: "Account Type"
    }
  },
  CLICK_PRICE_PAGE_CTA: {
    name: "Click Price Page CTA",
    properties: {
      CTA_LABEL: "CTA Label"
    }
  },
  EMAIL_SUBMIT_LEARN: {
    name: "Submit email",
    properties: {
      "Form name": "learn"
    }
  },
  EMAIL_SUBMIT_COIN_PAGE: {
    name: "Submit email",
    properties: {
      "Form name": "coin"
    }
  },
  EMAIL_SUBMIT_FOOTER: {
    name: "Submit Email",
    properties: {
      "Form name": "footer"
    }
  },
  DISMISS_MODAL_LEARN: {
    name: "Dismiss modal",
    properties: {
      "Modal name": "learn email"
    }
  },
  DISMISS_MODAL_COIN_PAGE: {
    name: "Dismiss modal",
    properties: {
      "Modal name": "coin email"
    }
  },
  CRYPTOPEDIA_EMAIL_SUBMIT_HOMEPAGE: {
    name: "Submit email",
    properties: {
      referrer: "cryptopedia",
      "Form name": "cryptopedia homepage email"
    }
  },
  CRYPTOPEDIA_EMAIL_SUBMIT_MODAL: {
    name: "Submit email",
    properties: {
      referrer: "cryptopedia",
      "Form name": "cryptopedia header email modal"
    }
  },
  CRYPTOPEDIA_EMAIL_SUBMIT_MOBILE: {
    name: "Submit email",
    properties: {
      referrer: "cryptopedia",
      "Form name": "cryptopedia mobile nav email"
    }
  },
  TRY_ACTIVE_TRADER_CLICK: {
    name: "Try ActiveTrader",
    properties: {
      source: "Source",
      currency: "Currency"
    }
  },
  SOCIAL_SHARE_BUTTON_CLICK: {
    name: "Social Share Button Click",
    properties: {
      COIN_NAME: "Coin Name"
    }
  },
  SOCIAL_SHARE_PLATFORM_ICON_CLICK: {
    name: "Social Share Platform Icon Click",
    properties: {
      COIN_SYMBOL: "Coin Symbol",
      COIN_PRICE: "Coin Price",
      PERCENTAGE_CHANGE: "Percentage Change",
      SOCIAL_PLATFORM_NAME: "Social Platform Name"
    }
  },
  DEMO_ACTIVETRADER_UI_STICKY_BUTTON: {
    name: "Demo ActiveTrader UI - Sticky Button",
    properties: {}
  },
  DEMO_ACTIVETRADER_UI_HERO: {
    name: "Demo ActiveTrader UI - Hero",
    properties: {}
  },
  ACTIVE_TRADER_SIGNUP: {
    name: "SignUp ActiveTrader"
  },
  ACTIVE_TRADER_DEMO: {
    name: "Demo ActiveTrader"
  },
  CONVERTER_FORM_PAIR_SELECTION: {
    name: "Converter form pair selection",
    properties: {
      BASE_CURRENCY: "Base Currency",
      QUOTE_CURRENCY: "Quote Currency"
    }
  },
  CONVERTER_FORM_UNSUPPORTED_PAIR: {
    name: "Converter form unsupported pair",
    properties: {
      BASE_CURRENCY: "Base Currency",
      QUOTE_CURRENCY: "Quote Currency"
    }
  }
};
